// Small request-type card shared by the portal homepage (unassigned bucket
// + search results) and the per-group page. A single component keeps the
// catalog look consistent everywhere a request type is listed.
import React from 'react';
import { Link } from 'react-router-dom';
import { CaretRight } from '@phosphor-icons/react';

export default function PortalRtCard({ rt, slug, theme }) {
  return (
    <Link
      to={`/help/${slug}/request/${rt.request_type_id}`}
      className="bg-white border border-zinc-200 rounded-lg p-4 hover:shadow-md transition-shadow flex items-start gap-3 group"
      data-testid={`portal-rt-${rt.request_type_id}`}
    >
      {rt.image_url ? (
        <img src={rt.image_url} alt="" className={`w-9 h-9 rounded-md ring-1 ring-zinc-200 bg-zinc-50 flex-shrink-0 ${(rt.image_fit || 'contain') === 'contain' ? 'object-contain p-0.5' : 'object-cover'}`} />
      ) : (
        <div className="w-9 h-9 rounded-md flex items-center justify-center flex-shrink-0 text-white font-bold text-sm"
          style={{ background: theme }}>{(rt.name || '?').charAt(0).toUpperCase()}</div>
      )}
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-zinc-900 text-sm">{rt.name}</p>
        {rt.description && <p className="text-xs text-zinc-500 mt-0.5">{rt.description}</p>}
      </div>
      <CaretRight size={14} className="text-zinc-400 group-hover:text-zinc-900 transition-colors mt-1" />
    </Link>
  );
}
